import * as React from "react";
import { RouteComponentProps } from "react-router";
import TopicBaseTimeline from "views/Topic/Components/TopicBaseTimeline";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
}

interface IRouteParams {
    id: string;
}

type Props = IProps & RouteComponentProps<IRouteParams>;

/////////////////////////////////////////////////////////////////////////////////////

const TopicViewer: React.FC<Props> = (props) => {
    return (
        <TopicBaseTimeline
            topicId={props.match.params.id}
            timestamp={new Date()}
            {...props}
        />
    );
};

export default TopicViewer;